<div class="persons-result">
  <div class="persons-header" *ngIf="persons().length > 0">
    <span class="persons-count"
      >{{ persons().length }} person{{
        persons().length !== 1 ? 's' : ''
      }}</span
    >
  </div>

  <div class="persons-grid">
    <div
      *ngFor="let p of persons()"
      class="person-tile-click"
      (click)="openDetail(p)"
    >
      <ui-person-tile
        [label]="p.name || 'Unknown'"
        [imageUrl]="p.bestImage"
        [imageUrlFallback]="p.bestImage"
        [showCheckbox]="false"
        [showConfirmationStatus]="true"
        [isConfirmed]="p.trainingStatus === 1"
        (confirm)="recognize(p)"
      >
        <div class="flex-row gap-4" (click)="$event.stopPropagation()">
          <ui-button
            iconClass="ui-icon-edit"
            type="secondary"
            [rounded]="true"
            [matTooltip]="'COMMON.EDIT' | translate"
            matTooltipClass="sidebar-tooltip"
            (clickAction)="edit(p)"
          ></ui-button>
          <ui-button
            iconClass="ui-icon-delete"
            type="secondary"
            [rounded]="true"
            [matTooltip]="'COMMON.DELETE' | translate"
            matTooltipClass="sidebar-tooltip"
            (clickAction)="delete(p)"
          ></ui-button>
        </div>
      </ui-person-tile>
    </div>
  </div>

  <div *ngIf="persons().length === 0" class="empty-state">
    No persons found.
  </div>

  <!-- Detail modal -->
  <div
    *ngIf="selectedPerson() as person"
    class="detail-overlay"
    (click)="closeDetail()"
  >
    <div class="detail-modal" (click)="$event.stopPropagation()">
      <button class="close-btn" (click)="closeDetail()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M18 6L6 18M6 6l12 12"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </button>

      <div class="detail-title">{{ person.name || 'Unknown' }}</div>

      <div class="detail-card">
        <!-- Avatar -->
        <div class="detail-avatar">
          <img
            *ngIf="person.bestImage"
            [appAuthSrc]="person.bestImage"
            [alt]="person.name || 'Person'"
          />
          <span
            *ngIf="!person.bestImage"
            class="avatar-initials detail-initials"
            >{{ initials(person) }}</span
          >
        </div>

        <!-- Info rows -->
        <div class="detail-info">
          <div class="detail-name">{{ person.name || 'Unknown' }}</div>
          <div class="detail-row">
            <span class="detail-label">Last Seen</span>
            <span class="detail-value">{{
              formatLastSeen(person.lastSeen)
            }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Appearances</span>
            <span class="detail-value">{{
              formatNumber(person.appearances)
            }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Status</span>
            <span class="detail-value">{{
              formatTrainingStatus(person.trainingStatus)
            }}</span>
          </div>
        </div>
      </div>

      <button
        class="search-appearances-btn"
        [class.loading]="searchingAppearances()"
        [disabled]="searchingAppearances() || !person.personId"
        (click)="searchAppearances(person)"
      >
        <svg
          *ngIf="!searchingAppearances()"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.35-4.35" />
        </svg>
        <span>{{
          searchingAppearances() ? 'Searching…' : 'Search Appearances'
        }}</span>
      </button>
    </div>
  </div>
</div>
